function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#179CC5",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M12 4c-4.412 0-8 3.588-8 8 0 4.413 3.588 8 8 8 4.413 0 8-3.587 8-8 0-4.412-3.587-8-8-8zm-1.813 4.637c0-.137.163-.325.288-.387 1.338-.638 2.7-1.25 4.037-1.875.525-.237 1.025-.175 1.45.213a30.2 30.2 0 0 1 1.425 1.437c.1.1.113.3.163.45-.137.037-.275.075-.425.113-.275.062-.563.087-.813.212-1.85.875-3.7 1.787-5.562 2.675-.162.075-.313.138-.575.263 0-1.113-.013-2.1.012-3.1zm6.388 6c-.625.025-1.25.025-1.862 0-.138-.012-.338-.137-.4-.274-.575-1.1-1.126-2.213-1.713-3.388.925-.45 1.787-.862 2.7-1.313.675 1.3 1.363 2.55 1.988 3.838.262.537-.1 1.1-.713 1.137zm-9-7.687c.7-.575 1.425-1.088 2.312-1.288v8.95H6.962v-.55c0-1.925.013-3.837 0-5.762 0-.563.188-1 .613-1.35zm6.675 10.825h-2.238c-.725 0-1.462-.05-2.187.013-1.063.087-1.9-.35-2.587-1.163a26.15 26.15 0 0 1-1.013-1.313c-.075-.1-.075-.287-.037-.4.012-.05.212-.062.325-.05.312.025.625.1.95.1 3 .013 6.012.013 9.012 0 .35 0 .7-.075 1.05-.112.1-.012.263 0 .288.05.05.1.05.262.012.362-.525 1.35-2.188 2.513-3.575 2.513z"
}));

var SvgIcKkp = function SvgIcKkp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcKkp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_kkp.8ca8585b.svg";
export { ForwardRef as ReactComponent };